<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Groupe de sécurité :</label>
        </div>
        <div class="col-4">
          <InputText type="string" v-model="critereGroupeSecurite" />
        </div>
      </div>
    </div>
  </div>
  <div class="row"/>
  <div v-if="isRechercheDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="redirectionAjouterGroupeSecurite"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>

export default {
  props: ['isRechercheDataLoading'],
  emits: ['rechercher'],
  data() {
    return {
      critereGroupeSecurite: null
    }
  },
  methods: {
    redirectionAjouterGroupeSecurite() {
      this.$router.push({name: "ajouterGroupesSecurite"});
    },
    rechercher(){
      if (this.critereGroupeSecurite === "") {
        this.critereGroupeSecurite = "null";
      }
      this.$emit('rechercher', this.critereGroupeSecurite);
      this.critereGroupeSecurite = "";
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
